import { Model } from '@/app/shared/models/model';
import { CampaignRulesMessageType } from '@/app/shared/enums';

export class CampaignRules extends Model {
  public CampaignId!: string;
  public MessageType!: CampaignRulesMessageType;
  public ProviderId!: string;
  public FileId!: number;
  public DaysToGenerate!: number;
  public PercentSample!: number;
  public NotifyCampaignId!: string;
  public NotifyCommunicationId!: string;
}
